import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-footer',
    templateUrl: './modal-footer.component.html',
    standalone: false
})
export class ModalFooterComponent {

}
